@if (!isEmpty()) {
  <div class="bai-playbooks__row" (click)="$event.stopPropagation()">
    <span class="bai-playbooks__label" aria-hidden="true">
      <i class="pi pi-bolt bai-playbooks__label-icon"></i> Suggestions
    </span>

    <!-- Inline chips (first VISIBLE_COUNT) -->
    <div
      class="bai-playbooks__chips"
      role="group"
      aria-label="Suggestion quick queries"
    >
      @for (pb of visiblePlaybooks(); track pb.id) {
        <button
          type="button"
          class="bai-playbooks__chip"
          [class.bai-playbooks__chip--loading]="inFlight().has(pb.id)"
          [disabled]="isDisabled(pb.id)"
          [attr.title]="pb.label"
          [attr.aria-label]="pb.label + (inFlight().has(pb.id) ? ' — running' : '')"
          [attr.aria-busy]="inFlight().has(pb.id)"
          (click)="runPlaybook(pb.id)"
        >
          @if (inFlight().has(pb.id)) {
            <i class="pi pi-spin pi-spinner bai-playbooks__chip-icon" aria-hidden="true"></i>
          }
          {{ pb.label }}
        </button>
      }
    </div>

    <!-- Overflow "More" button + dropdown -->
    @if (hasOverflow()) {
      <div class="bai-playbooks__overflow">
        <button
          type="button"
          class="bai-playbooks__more-btn"
          [class.bai-playbooks__more-btn--open]="showOverflow()"
          [attr.aria-expanded]="showOverflow()"
          aria-haspopup="true"
          aria-label="Show more suggestions"
          (click)="toggleOverflow()"
        >
          {{ overflowLabel() }}
          <i
            class="pi bai-playbooks__more-chevron"
            [class.pi-chevron-up]="showOverflow()"
            [class.pi-chevron-down]="!showOverflow()"
            aria-hidden="true"
          ></i>
        </button>

        @if (showOverflow()) {
          <div
            class="bai-playbooks__dropdown"
            role="menu"
            aria-label="Additional suggestions"
          >
            @for (pb of overflowPlaybooks(); track pb.id) {
              <button
                type="button"
                class="bai-playbooks__dropdown-item"
                [class.bai-playbooks__dropdown-item--loading]="inFlight().has(pb.id)"
                [disabled]="isDisabled(pb.id)"
                role="menuitem"
                [attr.aria-label]="pb.label + (inFlight().has(pb.id) ? ' — running' : '')"
                [attr.aria-busy]="inFlight().has(pb.id)"
                (click)="runPlaybookAndClose(pb.id)"
              >
                @if (inFlight().has(pb.id)) {
                  <i class="pi pi-spin pi-spinner bai-playbooks__chip-icon" aria-hidden="true"></i>
                } @else {
                  <i [class]="pb.icon + ' bai-playbooks__chip-icon'" aria-hidden="true"></i>
                }
                {{ pb.label }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
}
